function RedLabel(props: any) {
  return <label className="danger-label">{props.dangerLabel}</label>;
}

export default RedLabel;
